import { render } from "./BaseGoalList.vue?vue&type=template&id=206bd7dc&ts=true"
import script from "./BaseGoalList.vue?vue&type=script&lang=ts"
export * from "./BaseGoalList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__